import React, { useEffect } from "react";
import { Card, Button, Input, Row, Col, Form } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { setFormFieldValue } from "../../../../../helpers/FormHelper";



const rules = {
    name: [
        {
            required: true,
            message: "Plotësoni emrin!",
        },
        {
            min: 2,
            message: "Plotësoni minimumi 2 karaktere!"
        }
    ],
    surname: [
        {
            required: true,
            message: "Plotësoni mbiemrin!",
        },
        {
            min: 2,
            message: "Plotësoni minimumi 2 karaktere!"
        }
    ],
};



const Search = ({ dispatch, initialFilters, clearLoading, searchLoading, setLoadingType }) => {
    const [form] = Form.useForm();


    useEffect(() => {
        form.setFieldsValue({
            nid: setFormFieldValue(initialFilters?.nid),
            name: setFormFieldValue(initialFilters?.name),
            surname: setFormFieldValue(initialFilters?.surname),
            father_name: setFormFieldValue(initialFilters?.father_name),
        });
    }, [form, initialFilters]);


    const onSearch = async () => {
        try {
            const data = await form.validateFields();
            const { name, surname, father_name } = data;
            const requestFilters = {
                name: setFormFieldValue(name),
                surname: setFormFieldValue(surname),
                father_name: setFormFieldValue(father_name),
            };
            const action = {
                type: "set_search_filters",
                payload: requestFilters,
            };
            dispatch(action);
        } catch (error) {
            if (error?.values) return;
        }
    };


    const onClear = () => {
        setLoadingType('clear');
        const action = {
            type: "set_search_filters",
            payload: {
                name: null,
                surname: null,
                father_name: null,
            },
        };
        dispatch(action);
        form.resetFields();
    };


    const onEnter = (event) => {
        if (event.key === "Enter") {
            onSearch();
        }
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Form
                    form={form}
                    layout="vertical"
                    name="advanced_search"
                    className="ant-advanced-search-form"
                    onKeyDown={onEnter}
                >
                    <Card style={{ borderRadius: "0" }} bodyStyle={{ paddingBottom: "5px" }} className="pb-0">
                        <Row gutter={24} align="bottom">
                            <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                                <Form.Item name="name" label="Emri:" rules={rules.name}>
                                    <Input
                                        allowClear
                                        prefix={<SearchOutlined />}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                                <Form.Item name="surname" label="Mbiemri:" rules={rules.surname}>
                                    <Input
                                        allowClear
                                        prefix={<SearchOutlined />}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                                <Form.Item name="father_name" label="Atësia:">
                                    <Input
                                        allowClear
                                        prefix={<SearchOutlined />}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={3} lg={3} md={6} sm={12} xs={12}>
                                <Form.Item>
                                    <Button
                                        block
                                        ghost
                                        type="primary"
                                        loading={searchLoading}
                                        icon={<SearchOutlined />}
                                        onClick={onSearch}
                                    >
                                        Kërko
                                    </Button>
                                </Form.Item>
                            </Col>
                            <Col xl={3} lg={3} md={6} sm={12} xs={12}>
                                <Form.Item>
                                    <Button
                                        block
                                        danger
                                        loading={clearLoading}
                                        icon={<ClearOutlined />}
                                        onClick={onClear}
                                    >
                                        Pastro
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>
                </Form>
            </Col>
        </Row>
    );
};

export default Search;